module.exports = __webpack_public_path__ + "d824df7eb2e268626a2dd9a6a741ac4e.woff2";